"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useEvent;
const react_1 = __importDefault(require("react"));
/** Attaches an event listener for `eventName` to `window`. */
function useEvent(eventName = "", eventHandler = () => { }, dependencies = []) {
    react_1.default.useEffect(() => {
        window.addEventListener(eventName, eventHandler);
        return () => window.removeEventListener(eventName, eventHandler);
    }, dependencies);
}
